import { Document, Font, StyleSheet } from '@react-pdf/renderer'

import { ResumesTemplateColorEnum } from '@gql/graphql'

import { BauhausResumeTemplate } from '@/components/templates/resume/BauhausResumeTemplate'
import { HarvardResumeTemplate } from '@/components/templates/resume/HarvardResumeTemplate'
import { NeueResumeTemplate } from '@/components/templates/resume/NeueResumeTemplate'
import { OxfordResumeTemplate } from '@/components/templates/resume/OxfordResumeTemplate'
import { TResumeBuilderForm } from '@/forms/types'
import { ResumesTemplateEnum } from '@/gql/__generated__/graphql'
import { ResumeDocumentContext } from '@/provider/ResumeDocumentProvider'

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/',
})

export const ResumeDocument = ({
  formValues,
  template,
  templateColorEnum,
}: {
  formValues: TResumeBuilderForm
  profilePictureUrl: string
  template?: ResumesTemplateEnum
  templateColorEnum: Maybe<ResumesTemplateColorEnum> | undefined
}) => {
  return (
    <ResumeDocumentContext.Provider value={{ formValues }}>
      <Document style={DocumentStyles.document}>
        {template == ResumesTemplateEnum.Harvard && <HarvardResumeTemplate />}
        {template == ResumesTemplateEnum.Neue && (
          <NeueResumeTemplate formValues={formValues} templateColorEnum={templateColorEnum} />
        )}
        {template == ResumesTemplateEnum.Oxford && (
          <OxfordResumeTemplate templateColorEnum={templateColorEnum} />
        )}
        {template == ResumesTemplateEnum.Bauhaus && <BauhausResumeTemplate />}
      </Document>
    </ResumeDocumentContext.Provider>
  )
}

const DocumentStyles = StyleSheet.create({
  document: {
    width: '100%',
  },
})
